import { useContext } from 'react';
import { Context } from '../../../DataStore';

import * as strings from '../../../data/strings';

import '../../../styles/marketing/v2/CallOut.scss';

const CallOut = () => {
  const { store } = useContext(Context);

  return (
    <div className="CallOut">
      <div className="callOutWrapper">
        <img 
          className="regionAward"
          src={`${process.env.REACT_APP_CF_MKT_ENDPOINT}png/region-10-award-sm.png`}
          alt="Region 10 Award" />
        <div className="callOut">
          {strings.default[store.language].Marketing.CallOut}
          <div className="callOutSmall">
            {strings.default[store.language].Marketing.CallOut2}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CallOut;
